import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBPXQDasA9cPWyt_kB5O43TyR6H21I8v0A",
    authDomain: "godrej-iot-platform.firebaseapp.com",
    projectId: "godrej-iot-platform",
    storageBucket: "godrej-iot-platform.appspot.com",
    messagingSenderId: "241530512536",
    appId: "1:241530512536:web:396ce023ae33ebf0535ced",
    measurementId: "G-3DCG070D7Y"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
export function requestPermission() {
    Notification.requestPermission().then((permission) => {
        console.log(permission);
        if (permission === 'granted') {
            /// for get token
            getToken(messaging, { vapidKey: "BOaBRuPAx43MchoX8wgwzh0geCComOrF30lzmUCOiydzOSUMjUY-cA92rRepQi2WcSgZzekdt2JSh2wzfawknGc" })
                .then((currenToken) => {
                    if (currenToken) {
                        sessionStorage.setItem('fcm', currenToken);
                    }
                    else {
                        console.log("No Token get");
                    }
                }).catch((err) => {
                    requestPermission();
                    console.log('An error occurred while retrieving token. ', err);
                    // ...
                });;
        }
        else {
            console.log("persmission not granted");
        }
    });
}